/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EditJiraEpicsInput = {
    jiraEpicIds?: Array<string | null> | null | undefined;
    forecastProjectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type EditJiraEpicsMutationVariables = {
    input: EditJiraEpicsInput;
};
export type EditJiraEpicsMutationResponse = {
    readonly editJiraEpics: {
        readonly project: {
            readonly id: string;
            readonly isJiraProject: boolean | null;
            readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
            readonly jiraCloudProjectSettings: {
                readonly isSyncDone: boolean | null;
            } | null;
        } | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type EditJiraEpicsMutation = {
    readonly response: EditJiraEpicsMutationResponse;
    readonly variables: EditJiraEpicsMutationVariables;
};



/*
mutation EditJiraEpicsMutation(
  $input: EditJiraEpicsInput!
) {
  editJiraEpics(input: $input) {
    project {
      id
      isJiraProject
      jiraCloudEpicIds
      jiraCloudProjectSettings {
        isSyncDone
        id
      }
    }
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "EditJiraEpicsInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudEpicIds",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSyncDone",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditJiraEpicsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditJiraEpicsPayload",
        "kind": "LinkedField",
        "name": "editJiraEpics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditJiraEpicsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditJiraEpicsPayload",
        "kind": "LinkedField",
        "name": "editJiraEpics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "EditJiraEpicsMutation",
    "operationKind": "mutation",
    "text": "mutation EditJiraEpicsMutation(\n  $input: EditJiraEpicsInput!\n) {\n  editJiraEpics(input: $input) {\n    project {\n      id\n      isJiraProject\n      jiraCloudEpicIds\n      jiraCloudProjectSettings {\n        isSyncDone\n        id\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '1bb44febdffed2b83849b7fb4cc7a4f8';
export default node;
